/**
 * @generated SignedSource<<c698c4cdb7bc45ea88aadb8f9505b230>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Mutation } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type Platform = "META" | "%future added value";
export type CreateVisualAssetRequest = {
  metaAdId?: string | null;
  platform: Platform;
  preSignedUrl: string;
};
export type MetaAdsFilter = {
  approved?: boolean | null;
  count?: number | null;
  created?: boolean | null;
  cursor?: string | null;
  submittedForApproval?: boolean | null;
};
export type CreativeDrawerCreateVisualAssetMutation$variables = {
  input: CreateVisualAssetRequest;
  metaAdsFilter?: MetaAdsFilter | null;
};
export type CreativeDrawerCreateVisualAssetMutation$data = {
  readonly createVisualAsset: {
    readonly id: string;
    readonly metaAd: {
      readonly brand: {
        readonly id: string;
        readonly " $fragmentSpreads": FragmentRefs<"CreativeList" | "SubmitCreativeForApprovalConfirmDialogBrand">;
      };
      readonly id: string;
      readonly " $fragmentSpreads": FragmentRefs<"CreativeDrawerMetaAd">;
    };
  };
};
export type CreativeDrawerCreateVisualAssetMutation = {
  response: CreativeDrawerCreateVisualAssetMutation$data;
  variables: CreativeDrawerCreateVisualAssetMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input"
  },
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "metaAdsFilter"
  }
],
v1 = {
  "kind": "Variable",
  "name": "metaAdsFilter",
  "variableName": "metaAdsFilter"
},
v2 = [
  {
    "kind": "Variable",
    "name": "input",
    "variableName": "input"
  },
  (v1/*: any*/)
],
v3 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v4 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "approved",
  "storageKey": null
},
v5 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "created",
  "storageKey": null
},
v6 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "submittedForApproval",
  "storageKey": null
},
v7 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "text",
  "storageKey": null
},
v8 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "picture",
  "storageKey": null
},
v9 = {
  "alias": null,
  "args": null,
  "concreteType": "Comment",
  "kind": "LinkedField",
  "name": "comments",
  "plural": true,
  "selections": [
    (v3/*: any*/),
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "createdAt",
      "storageKey": null
    },
    (v7/*: any*/),
    {
      "alias": null,
      "args": null,
      "concreteType": "User",
      "kind": "LinkedField",
      "name": "user",
      "plural": false,
      "selections": [
        (v3/*: any*/),
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "fullName",
          "storageKey": null
        },
        (v8/*: any*/)
      ],
      "storageKey": null
    }
  ],
  "storageKey": null
},
v10 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "type",
  "storageKey": null
},
v11 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "url",
  "storageKey": null
},
v12 = {
  "alias": null,
  "args": null,
  "concreteType": "Insight",
  "kind": "LinkedField",
  "name": "insights",
  "plural": true,
  "selections": [
    (v3/*: any*/),
    (v7/*: any*/),
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "isMet",
      "storageKey": null
    }
  ],
  "storageKey": null
},
v13 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "callToAction",
  "storageKey": null
},
v14 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "name",
  "storageKey": null
},
v15 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "description",
  "storageKey": null
},
v16 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "destinationUrl",
  "storageKey": null
},
v17 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "displayUrl",
  "storageKey": null
},
v18 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "headline",
  "storageKey": null
},
v19 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "primaryText",
  "storageKey": null
},
v20 = [
  (v3/*: any*/),
  (v14/*: any*/),
  (v8/*: any*/)
],
v21 = {
  "alias": null,
  "args": null,
  "concreteType": "MetaAdSet",
  "kind": "LinkedField",
  "name": "metaAdSet",
  "plural": false,
  "selections": [
    (v3/*: any*/),
    (v14/*: any*/),
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "campaignName",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "MetaAdAccount",
      "kind": "LinkedField",
      "name": "metaAdAccount",
      "plural": false,
      "selections": [
        (v3/*: any*/),
        (v14/*: any*/)
      ],
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "effectiveStatus",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "status",
      "storageKey": null
    }
  ],
  "storageKey": null
},
v22 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "facebookPageId",
  "storageKey": null
},
v23 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "instagramAccountId",
  "storageKey": null
},
v24 = [
  (v14/*: any*/),
  (v8/*: any*/),
  (v3/*: any*/)
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "CreativeDrawerCreateVisualAssetMutation",
    "selections": [
      {
        "alias": null,
        "args": (v2/*: any*/),
        "concreteType": "VisualAsset",
        "kind": "LinkedField",
        "name": "createVisualAsset",
        "plural": false,
        "selections": [
          (v3/*: any*/),
          {
            "alias": null,
            "args": null,
            "concreteType": "MetaAd",
            "kind": "LinkedField",
            "name": "metaAd",
            "plural": false,
            "selections": [
              (v3/*: any*/),
              {
                "args": null,
                "kind": "FragmentSpread",
                "name": "CreativeDrawerMetaAd"
              },
              {
                "alias": null,
                "args": null,
                "concreteType": "Brand",
                "kind": "LinkedField",
                "name": "brand",
                "plural": false,
                "selections": [
                  (v3/*: any*/),
                  {
                    "args": null,
                    "kind": "FragmentSpread",
                    "name": "SubmitCreativeForApprovalConfirmDialogBrand"
                  },
                  {
                    "args": null,
                    "kind": "FragmentSpread",
                    "name": "CreativeList"
                  }
                ],
                "storageKey": null
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "CreativeDrawerCreateVisualAssetMutation",
    "selections": [
      {
        "alias": null,
        "args": (v2/*: any*/),
        "concreteType": "VisualAsset",
        "kind": "LinkedField",
        "name": "createVisualAsset",
        "plural": false,
        "selections": [
          (v3/*: any*/),
          {
            "alias": null,
            "args": null,
            "concreteType": "MetaAd",
            "kind": "LinkedField",
            "name": "metaAd",
            "plural": false,
            "selections": [
              (v3/*: any*/),
              (v4/*: any*/),
              (v5/*: any*/),
              (v6/*: any*/),
              (v9/*: any*/),
              {
                "alias": null,
                "args": null,
                "concreteType": "VisualAsset",
                "kind": "LinkedField",
                "name": "visualAssets",
                "plural": true,
                "selections": [
                  (v3/*: any*/),
                  (v10/*: any*/),
                  (v11/*: any*/)
                ],
                "storageKey": null
              },
              (v12/*: any*/),
              (v13/*: any*/),
              (v14/*: any*/),
              (v15/*: any*/),
              (v16/*: any*/),
              (v17/*: any*/),
              (v18/*: any*/),
              (v19/*: any*/),
              {
                "alias": null,
                "args": null,
                "concreteType": "FacebookPage",
                "kind": "LinkedField",
                "name": "facebookPage",
                "plural": false,
                "selections": (v20/*: any*/),
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "concreteType": "InstagramAccount",
                "kind": "LinkedField",
                "name": "instagramAccount",
                "plural": false,
                "selections": (v20/*: any*/),
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "concreteType": "MetaAdMetaAdSet",
                "kind": "LinkedField",
                "name": "metaAdMetaAdSets",
                "plural": true,
                "selections": [
                  (v21/*: any*/),
                  (v3/*: any*/)
                ],
                "storageKey": null
              },
              (v22/*: any*/),
              (v23/*: any*/),
              {
                "alias": null,
                "args": null,
                "concreteType": "Brand",
                "kind": "LinkedField",
                "name": "brand",
                "plural": false,
                "selections": [
                  (v3/*: any*/),
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "invalidDraftMetaAdCount",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": [
                      (v1/*: any*/)
                    ],
                    "concreteType": "MetaAd",
                    "kind": "LinkedField",
                    "name": "metaAds",
                    "plural": true,
                    "selections": [
                      (v3/*: any*/),
                      (v13/*: any*/),
                      (v15/*: any*/),
                      (v16/*: any*/),
                      (v17/*: any*/),
                      (v18/*: any*/),
                      (v19/*: any*/),
                      (v22/*: any*/),
                      (v23/*: any*/),
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "FacebookPage",
                        "kind": "LinkedField",
                        "name": "facebookPage",
                        "plural": false,
                        "selections": (v24/*: any*/),
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "InstagramAccount",
                        "kind": "LinkedField",
                        "name": "instagramAccount",
                        "plural": false,
                        "selections": (v24/*: any*/),
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "MetaAdMetaAdSet",
                        "kind": "LinkedField",
                        "name": "metaAdMetaAdSets",
                        "plural": true,
                        "selections": [
                          (v3/*: any*/),
                          (v21/*: any*/)
                        ],
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "VisualAsset",
                        "kind": "LinkedField",
                        "name": "visualAssets",
                        "plural": true,
                        "selections": [
                          (v10/*: any*/),
                          (v11/*: any*/),
                          (v3/*: any*/)
                        ],
                        "storageKey": null
                      },
                      (v4/*: any*/),
                      (v5/*: any*/),
                      (v6/*: any*/),
                      (v9/*: any*/),
                      (v12/*: any*/),
                      (v14/*: any*/),
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "Brand",
                        "kind": "LinkedField",
                        "name": "brand",
                        "plural": false,
                        "selections": [
                          (v3/*: any*/)
                        ],
                        "storageKey": null
                      }
                    ],
                    "storageKey": null
                  }
                ],
                "storageKey": null
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "57f4ad98f342f705da2e73665717e55c",
    "id": null,
    "metadata": {},
    "name": "CreativeDrawerCreateVisualAssetMutation",
    "operationKind": "mutation",
    "text": "mutation CreativeDrawerCreateVisualAssetMutation(\n  $input: CreateVisualAssetRequest!\n  $metaAdsFilter: MetaAdsFilter\n) {\n  createVisualAsset(input: $input, metaAdsFilter: $metaAdsFilter) {\n    id\n    metaAd {\n      id\n      ...CreativeDrawerMetaAd\n      brand {\n        id\n        ...SubmitCreativeForApprovalConfirmDialogBrand\n        ...CreativeList\n      }\n    }\n  }\n}\n\nfragment Comment on Comment {\n  id\n  createdAt\n  text\n  user {\n    id\n    fullName\n    picture\n  }\n}\n\nfragment CommentList on MetaAd {\n  comments {\n    id\n    ...Comment\n  }\n}\n\nfragment CreativeAdvisorInsight on Insight {\n  text\n  isMet\n}\n\nfragment CreativeAdvisorMetaAd on MetaAd {\n  insights {\n    id\n    text\n    ...CreativeAdvisorInsight\n  }\n}\n\nfragment CreativeDrawerMetaAd on MetaAd {\n  id\n  approved\n  created\n  submittedForApproval\n  comments {\n    id\n  }\n  visualAssets {\n    id\n  }\n  ...CreativeAdvisorMetaAd\n  ...CreativeTextForm\n  ...CommentList\n  ...MetaAdPreview\n}\n\nfragment CreativeList on Brand {\n  metaAds(metaAdsFilter: $metaAdsFilter) {\n    id\n    ...MetaAd\n  }\n}\n\nfragment CreativeTextForm on MetaAd {\n  id\n  callToAction\n  name\n  description\n  destinationUrl\n  displayUrl\n  headline\n  primaryText\n  facebookPage {\n    id\n    name\n    picture\n  }\n  instagramAccount {\n    id\n    name\n    picture\n  }\n  metaAdMetaAdSets {\n    metaAdSet {\n      id\n      name\n      campaignName\n      metaAdAccount {\n        id\n        name\n      }\n      effectiveStatus\n      status\n    }\n  }\n}\n\nfragment MetaAd on MetaAd {\n  ...MetaAdPreview\n  ...CreativeDrawerMetaAd\n  id\n  approved\n  submittedForApproval\n  created\n  name\n  callToAction\n  description\n  destinationUrl\n  displayUrl\n  headline\n  primaryText\n  facebookPageId\n  instagramAccountId\n  brand {\n    id\n  }\n  comments {\n    id\n  }\n  visualAssets {\n    id\n  }\n}\n\nfragment MetaAdPreview on MetaAd {\n  id\n  callToAction\n  description\n  destinationUrl\n  displayUrl\n  headline\n  primaryText\n  facebookPageId\n  instagramAccountId\n  facebookPage {\n    name\n    picture\n  }\n  instagramAccount {\n    name\n    picture\n  }\n  metaAdMetaAdSets {\n    id\n  }\n  visualAssets {\n    type\n    url\n  }\n}\n\nfragment SubmitCreativeForApprovalConfirmDialogBrand on Brand {\n  id\n  invalidDraftMetaAdCount\n}\n"
  }
};
})();

(node as any).hash = "b48242a820de38efd9f7d4c66c8ca542";

export default node;
